module.exports = __webpack_public_path__ + "media/images/searchtop-a3d8c88a9c06d491ebc9e1ccfe0d6fda.png";